import React from 'react';
import {
  Stack,
  IconButton,
  ButtonGroup,
  Button,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

const CustomToolbar = (toolbar) => {
  const goToBack = () => {
    toolbar.onNavigate('PREV');
  };

  const goToNext = () => {
    toolbar.onNavigate('NEXT');
  };

  const goToCurrent = () => {
    toolbar.onNavigate('TODAY');
  };

  const viewButtons = ['day', 'week', 'month', 'agenda'];

  const handleViewChange = (view) => {
    toolbar.onView(view);
  };

  const label = () => {
    const date = toolbar.date;
    const view = toolbar.view;

    let dateString = '';
    switch (view) {
      case 'month':
        dateString = date.toLocaleString('en-GB', {
          month: 'long',
          year: 'numeric',
        });
        break;
      case 'week':
        dateString = `${date.toLocaleString('en-GB', {
          month: 'short',
          day: 'numeric',
        })} - ${new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + 6
        ).toLocaleString('en-GB', {
          month: 'short',
          day: 'numeric',
        })}`;
        break;
      case 'day':
        dateString = date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
        break;
      case 'agenda':
        dateString = `${date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short',
        })} - ${new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + 1
        ).toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short',
        })}`;
        break;
      default:
        dateString = date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short',
        });
    }

    return dateString;
  };

  return (
    <Stack
      justifyContent="end"
      gap={1}
      sx={{
        mb: '10px',
        mt: {
          md: '10px',
        },
        flexDirection: {
          xs: 'column-reverse',
          md: 'row',
        },
        alignItems: {
          xs: 'end',
          md: 'center',
        },
      }}
    >
      <Stack direction={'row'} alignItems="center" gap={1}>
        {toolbar.view !== 'agenda' && (
          <>
            <IconButton
              onClick={goToBack}
              sx={{
                background: '#f8f8f8',
              }}
            >
              <ChevronLeftRoundedIcon />
            </IconButton>

            <Typography
              variant={'subtitle1'}
              align={'center'}
              sx={{
                minWidth: '115px',
              }}
            >
              {label()}
            </Typography>
            <IconButton
              onClick={goToNext}
              sx={{
                background: '#f8f8f8',
              }}
            >
              <ChevronRightRoundedIcon />
            </IconButton>
          </>
        )}
      </Stack>
      <ButtonGroup
        variant="outlined"
        aria-label="outlined button group"
        sx={{
          width: {
            xs: '100%',
            md: 'auto',
          },
        }}
      >
        {viewButtons.map((view) => (
          <Button
            color={'secondary'}
            key={view}
            sx={{
              width: {
                xs: '100%',
                md: 'auto',
              },
            }}
            onClick={() => handleViewChange(view)}
            variant={toolbar.view === view ? 'contained' : 'outlined'}
          >
            {view.charAt(0).toUpperCase() + view.slice(1)}
          </Button>
        ))}
      </ButtonGroup>
    </Stack>
  );
};

export default CustomToolbar;
